"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalBusEnumerationAnalysisResultSerializedSchema = exports.LogicalBusAnalysisResultSerializedSchema = exports.LogicalBusDataSchema = exports.LogicalBusAssignmentDataSchema = exports.FunctionSignalConnectionSchema = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("./AnalysisType");
const SignalId_1 = require("../DesignModels/SignalId");
const IComponentFunctionAssignment_1 = require("../FunctionalModels/IComponentFunctionAssignment");
const IComponentFunctionClassParameters_1 = require("../FunctionalModels/IComponentFunctionClassParameters");
const IInsightError_1 = require("../IInsightError");
exports.FunctionSignalConnectionSchema = zod_1.z.object({
    functionSignalName: zod_1.z.string(),
    componentSignals: zod_1.z.array(zod_1.z.object({
        signalId: SignalId_1.SignalIdSchema,
        signalName: zod_1.z.string(),
        nets: zod_1.z.string().array(),
    })),
});
exports.LogicalBusAssignmentDataSchema = zod_1.z.object({
    moduleName: zod_1.z.string(),
    functionName: zod_1.z.string(),
    functionId: zod_1.z.string(),
    functionClass: zod_1.z.string(),
    assignment: zod_1.z.lazy(() => IComponentFunctionAssignment_1.IComponentFunctionAssignmentSchema),
    signalConnections: zod_1.z.lazy(() => exports.FunctionSignalConnectionSchema).array(),
    classParameters: zod_1.z.lazy(() => IComponentFunctionClassParameters_1.IComponentFunctionClassParametersSchema).optional(),
});
exports.LogicalBusDataSchema = zod_1.z.object({
    nets: zod_1.z.string().array(),
    className: zod_1.z.string(),
    assignments: zod_1.z.lazy(() => exports.LogicalBusAssignmentDataSchema).array(),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
exports.LogicalBusAnalysisResultSerializedSchema = zod_1.z.object({
    type: zod_1.z.literal(AnalysisType_1.AnalysisType.LogicalBus),
    result: zod_1.z.object({
        busId: zod_1.z.string(),
        circuitStateId: zod_1.z.string(),
        logicalBusData: zod_1.z.lazy(() => exports.LogicalBusDataSchema).array(),
    }),
});
exports.LogicalBusEnumerationAnalysisResultSerializedSchema = zod_1.z.object({
    type: zod_1.z.literal(AnalysisType_1.AnalysisType.LogicalBusEnumeration),
    result: zod_1.z.object({
        circuitStateIds: zod_1.z.string().array(),
        buses: zod_1.z.array(zod_1.z.object({
            busId: zod_1.z.string(),
            circuitStateIds: zod_1.z.string().array(),
        })),
    }),
});
//# sourceMappingURL=LogicalBusAnalysisResult.js.map